"use client";

import SearchInput from "@/app/components/SearchInput";

type FinancialWorkSearchBarProps = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  placeholder?: string;
  onHowItWorksClick?: () => void;
};

/** Top search chrome for Financial Work (งานเงิน / ข้อมูล). */
export function FinancialWorkSearchBar({
  searchQuery,
  setSearchQuery,
  placeholder = "ค้นหาเรื่องเงิน...",
  onHowItWorksClick,
}: FinancialWorkSearchBarProps) {
  return (
    <SearchInput
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      placeholder={placeholder}
      className="h-14 hidden min-[900px]:flex min-[1440px]:ps-[300px]"
      fieldClassName="max-w-2xl"
      onHowItWorksClick={onHowItWorksClick}
    />
  );
}
